import { render, staticRenderFns } from "./listing.vue?vue&type=template&id=8a5e4a54&scoped=true"
import script from "./listing.vue?vue&type=script&lang=js"
export * from "./listing.vue?vue&type=script&lang=js"
import style0 from "./listing.vue?vue&type=style&index=0&id=8a5e4a54&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5e4a54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a5e4a54')) {
      api.createRecord('8a5e4a54', component.options)
    } else {
      api.reload('8a5e4a54', component.options)
    }
    module.hot.accept("./listing.vue?vue&type=template&id=8a5e4a54&scoped=true", function () {
      api.rerender('8a5e4a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/announcement/listing.vue"
export default component.exports